import { render, staticRenderFns } from "./LayoutHorizontal.vue?vue&type=template&id=3b87021d"
import script from "./LayoutHorizontal.vue?vue&type=script&lang=js"
export * from "./LayoutHorizontal.vue?vue&type=script&lang=js"
import style0 from "./LayoutHorizontal.vue?vue&type=style&index=0&id=3b87021d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../4rahgit/GPS-Tracking-Client-Panel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports